type Variant = "default" | "new";

export default function DeleteIcon({
  variant = "default",
}: {
  variant?: Variant;
}) {
  const iconsMap: Record<Variant, JSX.Element> = {
    default: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="18"
        viewBox="0 0 16 18"
        fill="none"
      >
        <path
          d="M14.0498 6.62793C14.0498 6.62793 13.5949 12.2707 13.331 14.6477C13.2053 15.7829 12.504 16.4482 11.3554 16.4691C9.16945 16.5085 6.98104 16.511 4.79597 16.4649C3.69087 16.4423 3.00134 15.7687 2.87818 14.6535C2.61259 12.2556 2.16016 6.62793 2.16016 6.62793"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.2079 3.9238H1"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.471 3.92319C11.8133 3.92319 11.2469 3.4582 11.1179 2.8139L10.9143 1.7951C10.7886 1.32508 10.363 1 9.87791 1H6.33137C5.84626 1 5.42065 1.32508 5.29497 1.7951L5.09138 2.8139C4.96235 3.4582 4.39598 3.92319 3.73828 3.92319"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    new: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="33"
        height="33"
        viewBox="0 0 33 33"
        fill="none"
      >
        <g clipPath="url(#clip0_497_83747)">
          <path
            d="M5.7793 9.38477H27.1126"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.7793 14.7168V22.7168"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.1133 14.7168V22.7168"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.11328 9.38477L8.44661 25.3848C8.44661 26.092 8.72757 26.7703 9.22766 27.2704C9.72776 27.7705 10.406 28.0514 11.1133 28.0514H21.7799C22.4872 28.0514 23.1655 27.7705 23.6656 27.2704C24.1657 26.7703 24.4466 26.092 24.4466 25.3848L25.7799 9.38477"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12.4453 9.38411V5.38411C12.4453 5.03049 12.5858 4.69135 12.8358 4.44131C13.0859 4.19126 13.425 4.05078 13.7786 4.05078H19.112C19.4656 4.05078 19.8047 4.19126 20.0548 4.44131C20.3048 4.69135 20.4453 5.03049 20.4453 5.38411V9.38411"
            stroke="currentColor"
            strokeWidth="1.33333"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_497_83747">
            <rect
              width="32"
              height="32"
              fill="white"
              transform="translate(0.445312 0.0507812)"
            />
          </clipPath>
        </defs>
      </svg>
    ),
  };

  return iconsMap[variant];
}
